import { render, staticRenderFns } from "./BRadioButton.vue?vue&type=template&id=06ab155a&scoped=true"
import script from "./BRadioButton.vue?vue&type=script&lang=ts"
export * from "./BRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./BRadioButton.vue?vue&type=style&index=0&id=06ab155a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab155a",
  null
  
)

export default component.exports